import { render, staticRenderFns } from "./KitItems.vue?vue&type=template&id=0c987a44"
import script from "./KitItems.vue?vue&type=script&lang=js"
export * from "./KitItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports